import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';

// tslint:disable:nx-enforce-module-boundaries
import { Environment } from '@elight/client/shared/utility/common';
import { ApiService } from '@elight/client/shared/data-access/common';
// tslint:enable:nx-enforce-module-boundaries

import { ClientSharedDataAccessUserModule } from './user.module';
import { UserDTO } from './user.dto';

@Injectable({
    providedIn: ClientSharedDataAccessUserModule,
})
export class UserService extends ApiService<UserDTO> {
    constructor(protected httpClient: HttpClient, protected env: Environment) {
        super(httpClient, env, 'users');
    }

    public get(params: string = '') {
        // @TODO workaround until we fix the users api to return the same payload as other endpoint
        return super.get().pipe(map((response: any) => response.items));
    }

    public inviteUser(payload: {
        email: string;
        role_type: string;
        legacy_role_type: string;
    }) {
        const url = `${this.env.api.baseURL}/invites`;
        return this.httpClient.post(url, payload);
    }

    public getInviteByCode(code: string) {
        const url = `${this.env.api.baseURL}/registration/invite/code/${code}`;
        return this.httpClient.get(url);
    }

    public checkUserExistsByEmail(email: string) {
        const url = `${this.env.api.baseURL}/registration/user/email/${email}`;
        return this.httpClient.get(url);
    }

    public getInvites() {
        const url = `${this.env.api.baseURL}/invites`;
        return this.httpClient.get(url);
    }

    public resendInvitation(id: string) {
        const url = `${this.env.api.baseURL}/invites/${id}/resend`;
        return this.httpClient.post(url, {});
    }

    public deleteInvitation(id: string) {
        const url = `${this.env.api.baseURL}/invites/${id}`;
        return this.httpClient.delete(url);
    }
}
